import { CleanButton, IThemeProps, cleanButtonStyle, theme } from '@arnold/common';
import { css } from '@emotion/react/macro';
import styled from '@emotion/styled/macro';
import { Button } from 'react-bootstrap';
import DropdownItem from 'react-bootstrap/DropdownItem';
import DropdownMenu from 'react-bootstrap/DropdownMenu';
import { Link } from 'react-router-dom';
import { Card } from './Common';
import { Aside } from './Common/PublicLayout';

export const SurveyScreenHeading = styled.div`
  display: flex;
`;

export const WarningText = styled.span`
  color: ${theme.colors.emotionWarning.active};
`;

export const SurveyDetailContent = styled(Card)`
  border-top: 1px solid ${theme.colors.borderSeparator.default};
`;

interface ILinkProps extends IThemeProps {
  weight?: number;
}
const generaLinkStyle = ({ theme, weight }: ILinkProps) => css`
  transition: color 0.2s ease;
  cursor: pointer;
  text-decoration: none;
  color: ${theme && theme.colors.actionPrimary.default};
  font-weight: ${weight};
  &:hover {
    color: ${theme && theme.colors.actionPrimary.hover};
    text-decoration: underline;
  }
  &:focus {
    color: ${theme && theme.colors.actionPrimary.focused};
    text-decoration: underline;
  }
  &:active {
    color: ${theme && theme.colors.actionPrimary.default};
    text-decoration: underline;
  }
`;

export const ErrorPage = styled.div`
  justify-content: center;
  margin: 60px;
  display: flex;
  font-size: 35px;
  color: #bdbdbd;
`;

export const AppLink = styled(Link)`
  ${generaLinkStyle};
`;

export const ClassicLink = styled.a`
  ${generaLinkStyle};
`;

export const ShowPasswordButton = styled(CleanButton)`
  position: absolute;
  top: 38px;
  right: ${theme.spacing.f};
  path {
    fill: ${theme.colors.actionPrimary.default};
  }
`;

export const ButtonLink = styled.button`
  ${cleanButtonStyle};
  ${generaLinkStyle};
  &:disabled {
    color: ${theme.colors.actionPrimary.disabled};
    cursor: auto;
    &:hover {
      text-decoration: none;
    }
  }
`;

export const DateSelector = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingBottom: '0.5rem',
}));

export const DateSelectorInputGroup = styled.div(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
}));

export const RegistrationAsideContent = styled(Aside)`
  justify-content: space-between;
  padding: ${theme.spacing.l};
  padding: 8%; /* ${theme.spacing.l}; */
  & svg {
    flex-shrink: 0;
  }

  @media (max-width: ${theme.breakpoint.small}) {
    padding: 0 0 0 ${theme.spacing.e};
  }
`;

export const HeadingContainer = styled.div`
  padding: ${theme.spacing.h} 0;
  max-width: 300px;

  @media (min-width: ${theme.breakpoint.small}) {
    padding: ${theme.spacing.i} 0 ${theme.spacing.g} 0;
  }
  & h1 {
    @media (max-width: ${theme.breakpoint.small}) {
      line-height: ${theme.typography.heading.medium.default.lineHeight};
      font-weight: ${theme.typography.heading.medium.default.fontWeight};
      font-size: ${theme.typography.heading.medium.default.fontSize};
    }
  }
`;

export const LogoContainer = styled.div`
  display: none;
  @media (min-width: ${theme.breakpoint.small}) {
    display: block;
    padding-bottom: ${theme.spacing.h};
  }
`;

export const ActionsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 1.5rem;
  align-items: flex-start;
  @media (max-width: ${theme.breakpoint.small}) {
    justify-content: center;
  }
`;

export const LinkWrap = styled.div`
  padding: ${theme.spacing.d} ${theme.spacing.g};
  margin-left: ${theme.spacing.f};
  @media (max-width: ${theme.breakpoint.small}) {
    margin-top: ${theme.spacing.f};
  }
`;

export const CheckboxGroup = styled.label`
  display: grid;
  grid-auto-flow: column;
  align-items: start;
  justify-content: start;

  input[type='checkbox'] {
    margin-top: 3px;
  }
`;

export const PrimaryButton = styled(Button)`
  width: 100%;
  margin: 0;
  @media (min-width: ${theme.breakpoint.small}) {
    width: auto;
  }
`;

const WIDTH = 154;

export const baseMenuStyles = css`
  width: ${WIDTH}px;
  margin-left: -${WIDTH / 2}px;
  margin-top: -20px;
  border-radius: ${theme.borderRadius.m};
  background: ${theme.colors.backgroundCover.default};
  color: ${theme.colors.text.primary};
  font-weight: ${theme.typography.body.medium.regular.fontWeight} !important;
  font-size: ${theme.typography.body.medium.regular.fontSize} !important;
  box-shadow: ${theme.shadows.elevationContentDialog} !important;
  overflow: hidden;
`;

export const baseItemStyles = css`
  &&:hover,
  &&:focus {
    background: var(--background-cover-01-default, #f5f5f5) !important;
    color: ${theme.colors.actionPrimary.default} !important;
  }
  transition: all 0.2s ease-in-out;
  padding: 10px !important;
  cursor: pointer;
  overflow: hidden;
  font-weight: ${theme.typography.body.medium.regular.fontWeight} !important;
  font-size: ${theme.typography.body.medium.regular.fontSize} !important;
  border-radius: 0 !important;
`;

export const StyledDropdownMenu = styled(DropdownMenu)`
  transition: none !important;
  ${baseMenuStyles}
`;

export const StyledDropdownItem = styled(DropdownItem)`
  ${baseItemStyles}
`;

export const LogoWithHeadingContainer = styled.div`
  @media (max-width: ${theme.breakpoint.small}) {
    display: flex;
    align-items: center;

    & > svg {
      width: 40px;
      height: 40px;
    }
    & > div {
      margin-left: ${theme.spacing.g};
    }
  }
`;
export const HideOnMobile = styled.div`
  @media (max-width: ${theme.breakpoint.small}) {
    display: none;
  }
`;

export const ExplanatoryList = styled.ul`
  color: ${theme.colors.text.secondary};
  padding-left: 22px;
  & > li > p {
    color: ${theme.colors.text.secondary} !important;
  }
`;
